/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { getState, Loading, Status, toCamel, ajax, evalJson, arrayFrom } from '../../twd/all'
import { Header } from './header'
import { Detail, DetailMobile } from './detail'
import { backgroundColor } from './style'

const Last = getState('orders-confirm.last', {
    detail: {},
})


export default ({orderNo, action, acctNo, cusip, note, backFrom}) => {
    const [detail, setDetail] = React.useState({})
    const [status, setStatus] = React.useState(Status.LOADING)

    React.useEffect(() => {
        if (backFrom) {
            setDetail(Last.value.detail)
            setStatus(Status.LOADED)
            return
        }

        ;(async ()=> {
            try {
                let postPowerPurchasing
                const p_action = action==='cancel' ? '4'
                    : action==='accept' ? 'A'
                    : null
                if (p_action) {
                    const params = {
                        p_submit: 'Submit',
                        p_validated: 'Y',
                        p_action,
                        p_order_no: arrayFrom(orderNo).join(),
                        p_cusip: cusip,
                        p_acct: acctNo || '',
                        p_text: note || ''
                    }
                    let {data:actionData} = await ajax({
                        url: '/esb/portfolio/trades/actions',
                        method: 'POST',
                        params,
                    })

                    let data = await actionData
                    if (data.actionStatus==='Error') {
                        throw new Error(`unable to execute action, ${JSON.stringify(params)}`)
                    }

                    postPowerPurchasing = data.postPowerPurchasing
                }


                let {data} = await ajax({
                    url:'/esb/portfolio/trades/details',
                    method: 'GET',
                    isDc: false,
                    type: 'text',
                    params: { orderNo }
                })

                const detail = parseDetail(await data)

                detail.postPowerPurchasing = postPowerPurchasing

                Last.set({detail});
                setDetail(detail)
                setStatus(Status.LOADED)

            } catch(e) {
                console.log(e)
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()
    }, [])

    const isCancel = action==='cancel'
    const isAccept = action==='accept'
    const title = isCancel ? 'Cancellation request submitted'
        : isAccept ? 'Order confirmation'
        : ''
    return <React.Fragment>
        <div className="container orders-confirm">
        <div className="row vertical-offset-xs">
        <div className="col-md-12 col-xs-12">
            <h1>{title}</h1>
        </div>
        </div>
        </div>

        <Loading status={status}>
        <div style={{backgroundColor:"#f6f6f6"}}>
        <div className="container">
            <Header detail={detail} action={action} />
            <div className="vertical-offset-base"></div>
        </div>
        </div>

        <div css={backgroundColor}>
        <div className="xs-hide container">
            <Detail detail={detail} action={action} />
        </div>

        <div className="xs-show container">
            <DetailMobile detail={detail} action={action} />
        </div>
        </div>


        <div className="vertical-offset-base"></div>

        </Loading>
    </React.Fragment>
}


const parseDetail = (txt) => {
  const d = evalJson(txt, {orderDetails:[]}).orderDetails[0]
  if (!d) return

  arrayFrom(d.AccountList)
  .concat(arrayFrom(d.OrderList))
  .concat(arrayFrom(d.PriceList))
  .forEach(({label, value, order}) => {
      const v  = value || order
      const n = toCamel(String(label).trim())
      d[n] = v
  })

  return d
}